import type { AnchorPlacement, AnimationOptions, Easing } from "@/types";

/** 預設選項 */
export const DEFAULT_OPTIONS: AnimationOptions = {
  offset: 120,
  delay: 0,
  duration: 400,
  easing: "none",
  once: false,
  mirror: false,
  anchorPlacement: "top-bottom",
  markers: false,
};

/** 動畫曲線 */
export const easings: Easing[] = [
  "none",
  "power1",
  "power1.in",
  "power1.out",
  "power1.inOut",
  "power2",
  "power2.in",
  "power2.out",
  "power2.inOut",
  "power3",
  "power3.in",
  "power3.out",
  "power3.inOut",
  "power4",
  "power4.in",
  "power4.out",
  "power4.inOut",
  "back",
  "back.in",
  "back.out",
  "back.inOut",
  "bounce",
  "bounce.in",
  "bounce.out",
  "bounce.inOut",
  "circ",
  "circ.in",
  "circ.out",
  "circ.inOut",
  "elastic",
  "elastic.in",
  "elastic.out",
  "elastic.inOut",
  "expo",
  "expo.in",
  "expo.out",
  "expo.inOut",
  "sine",
  "sine.in",
  "sine.out",
  "sine.inOut",
];

/** 動畫錨點 */
export const anchorPlacements: AnchorPlacement[] = [
  "top-bottom",
  "top-center",
  "top-top",
  "center-bottom",
  "center-center",
  "center-top",
  "bottom-bottom",
  "bottom-center",
  "bottom-top",
];
